<script lang="ts" setup>
defineProps({activePage: String});
</script>

<template>
  <aside class="col-lg-4 col-md-5 pe-xl-4 mb-5">
    <div class="card card-body border-0 shadow-sm pb-1 me-lg-1">
      <a class="btn btn-outline-secondary d-block d-md-none w-100 mb-3" data-bs-target="#politics"
         data-bs-toggle="collapse">
        <i class="fi-align-justify me-2"></i>Menu</a>
      <div class="collapse d-md-block mt-3" id="politics">
        <div class="card-nav">
          <NuxtLink :class="{'card-nav-link': true, 'active': activePage === 'privacy' }" to="/politicas/privacidade">
            <i class="fi-file opacity-60 me-2"></i>Política de Privacidade
          </NuxtLink>
          <NuxtLink :class="{'card-nav-link': true, 'active': activePage === 'cookies' }" to="/politicas/cookies">
            <i class="fi-file opacity-60 me-2"></i>Política de Cookies
          </NuxtLink>
<!--          <NuxtLink :class="{'card-nav-link': true, 'active': activePage === 'half-price' }"-->
<!--                    to="/politicas/meia-entrada">-->
<!--            <i class="fi-file opacity-60 me-2"></i>Meia-Entrada-->
<!--          </NuxtLink>-->
          <NuxtLink :class="{'card-nav-link': true, 'active': activePage === 'service-tax' }"
                    to="/politicas/taxas-servico">
            <i class="fi-file opacity-60 me-2"></i>Taxas de Serviço
          </NuxtLink>
          <NuxtLink :class="{'card-nav-link': true, 'active': activePage === 'use-terms' }"
                    to="/politicas/termos-de-uso">
            <i class="fi-file opacity-60 me-2"></i>Termos de Uso
          </NuxtLink>
        </div>
      </div>
    </div>
  </aside>
</template>
